import { useTranslate } from "@similarweb/i18n-provider";
import { Tooltip } from "@similarweb/ui-components";

import { OnboardingAgentNegativeFeedbackModal } from "../OnboardingAgentNegativeFeedbackModal/OnboardingAgentNegativeFeedbackModal";
import { ONBOARDING_AGENT_FEEDBACK_THUMBS_DOWN } from "../texts";

import { ReplyFeedbackThumbsDownIconButton } from "./styles";
import { useOnboardingAgentThumbsDownFeedback } from "./hooks/useOnboardingAgentThumbsDownFeedback";

type OnboardingAgentReplyThumbsDownButtonProps = {
    messageIndex: number;
    isActive: boolean;
    threadId?: string;
    onActiveChange: (active: boolean) => void;
    onClearLike: () => void;
    dataAutomation: string;
};

export const OnboardingAgentReplyThumbsDownButton = ({
    messageIndex,
    isActive,
    threadId,
    onActiveChange,
    onClearLike,
    dataAutomation,
}: OnboardingAgentReplyThumbsDownButtonProps) => {
    const { translate } = useTranslate();
    const { isModalOpen, comment, handleThumbClick, handleSubmitFeedback, handleCommentChange, dismissFeedbackModal } =
        useOnboardingAgentThumbsDownFeedback({
            messageIndex,
            isActive,
            threadId,
            onActiveChange,
            onClearLike,
        });

    return (
        <>
            <Tooltip
                content={translate(ONBOARDING_AGENT_FEEDBACK_THUMBS_DOWN)}
                placement="bottom"
            >
                <ReplyFeedbackThumbsDownIconButton
                    type="flat"
                    iconName={isActive ? "thumb-down" : "thumb-down-outline"}
                    iconSize="xs"
                    dataAutomation={dataAutomation}
                    $mirrorIcon={isActive}
                    onClick={handleThumbClick}
                />
            </Tooltip>

            <OnboardingAgentNegativeFeedbackModal
                isOpen={isModalOpen}
                messageIndex={messageIndex}
                comment={comment}
                onCommentChange={handleCommentChange}
                onClose={dismissFeedbackModal}
                onSubmit={handleSubmitFeedback}
            />
        </>
    );
};
